<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Autocomplete</strong></h4>
      <a href="https://mdbootstrap.com/vue/components/autocomplete/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr />
    <container class="mt-5">
      <h2 class="mb-5">Basic Example</h2>
      <row>
        <column md="6" class="mx-auto">
          <autocomplete
            icon="heart"
            clearClass="fa-lg"
            :data="states"
            label="What is your favorite US state?"
            @input="onInput"
          />
        </column>
      </row>

      <hr class="my-5">

      <h2 class="mb-5">Autocomplete within form</h2>

      <row>
        <column md="5">
          <card>
            <card-body class="mx-4">
              <div class="text-center">
                <h3 class="dark-grey-text mb-5"><strong>Sign up</strong></h3>
              </div>
              <mdb-input label="Your email" type ="email"/>
              <mdb-input label="Your password" type="password" containerClass="mb-0"/>
              <autocomplete :data="countries" label="Your country" class="pb-3"/>
              <div class="text-center mb-3">
                <btn type="button" gradient="blue" rounded class="btn-block z-depth-1a">Sign up</btn>
              </div>
              <p class="font-small dark-grey-text text-right d-flex justify-content-center mb-3 pt-2"> or Sign up with:</p>
              <div class="row my-3 d-flex justify-content-center">
                <btn type="button" color="white" rounded class="mr-md-3 z-depth-1a"><fa icon="facebook" class="blue-text text-center"/></btn>
                <btn type="button" color="white" rounded class="mr-md-3 z-depth-1a"><fa icon="twitter" class="blue-text"/></btn>
                <btn type="button" color="white" rounded class="z-depth-1a"><fa icon="google-plus" class="blue-text"/></btn>
              </div>
            </card-body>
            <modal-footer class="mx-5 pt-3 mb-1">
              <p class="font-small grey-text d-flex justify-content-end">Not a member? <a href="#" class="blue-text ml-1"> Sign In</a></p>
            </modal-footer>
          </card>
        </column>
      </row>

      <hr class="my-5">

      <h2 class="mb-5">Autocomplete within modal</h2>
      <row>
        <column md="6" style="margin-right: auto; margin-left: auto">

        <btn @click.native="showModal = true" rounded>Launch demo modal</btn>

        <modal v-if="showModal" @close="showModal=false" cascade>
          <modal-header class="light-blue darken-3 white-text">
              <h4 class="title"><fa icon="pencil"/> Contact form</h4>
          </modal-header>
          <modal-body>
            <mdb-input icon="envelope" label="Your name"/>
            <mdb-input icon="lock" label="Your email"/>
            <autocomplete icon="tag" label="Subject" :data="subjects"/>
            <md-textarea icon="pencil" label="Your message"/>

          <div class="text-center">
            <btn color="info" class="mb-2 waves-light">Send <fa icon="send" class="ml-1"></fa></btn>
          </div>
          </modal-body>
        </modal>

        </column>
      </row>
    </container>
  </container>
</template>

<script>
import { Autocomplete, Container, Row, Column, mdbInput, MdTextarea, Btn, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Fa } from 'mdbvue';

export default {
  methods: {
    onInput (val) {
      console.log(val);
    }
  },
  name: 'AutocompletePage',
  components: {
    Autocomplete,
    Container,
    Column,
    Row,
    mdbInput,
    MdTextarea,
    Btn,
    Card,
    CardBody,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Fa,
    Modal
  },
  data() {
    return {
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illnois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ],
      countries: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Central African Republic (CAR)",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macedonia (FYROM)",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Myanmar (Burma)",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (UAE)",
        "United Kingdom (UK)",
        "United States of America (USA)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City (Holy See)",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],
      subjects: [
        "Where's My Stuff?",
        "Cancel Items or Orders",
        "Returns & Refunds",
        "Shipping Rates & Information",
        "Change Your Payment Method",
        "Manage Your Account Information",
        "About Two-Step Verification",
        "Cancel Items or Orders",
        "Change Your Order Information",
        "Contact Third-Party Sellers",
        "More in Managing Your Orders"
      ],
      showModal: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.font-small {
  font-size: 0.8rem;
}
</style>
